import { useTracking } from '@change-corgi/core/react/tracking';

import { usePetitionEditPageData } from 'src/app/pages/petitionEditV2/pageContext';

type UsePageBreadcrumb = ModelHookResult<{ dashboardLink: string }, { dashboardLinkClicked: () => void }>;

export function usePageBreadcrumbData(): UsePageBreadcrumb {
	const {
		data: { petition },
	} = usePetitionEditPageData();
	const track = useTracking();

	return {
		data: {
			dashboardLink: `/p/${encodeURIComponent(petition.slug)}/dashboard`,
		},
		actions: {
			dashboardLinkClicked: () => {
				void track('edit_dashboard_breadcrumb_click');
			},
		},
	};
}
